define('controllers/fieldCheckboxList',[], function() {
    var controller = Marionette.Object.extend( {
        initialize: function() {
            this.listenTo( nfRadio.channel( 'listcheckbox' ), 'init:model', this.register );
            this.listenTo( nfRadio.channel( 'terms' ), 'init:model', this.register );
            nfRadio.channel( 'listcheckbox' ).reply( 'before:updateField', this.beforeUpdateField, this );
            nfRadio.channel( 'terms' ).reply( 'before:updateField', this.beforeUpdateField, this );
            nfRadio.channel( 'listcheckbox' ).reply( 'get:calcValue', this.getCalcValue, this );
            nfRadio.channel( 'terms' ).reply( 'get:calcValue', this.getCalcValue, this );

            /*
             * Answer the required check ourselves. The shared check reads the value
             * of whichever element just changed, which for the Terms List add-new
             * box is empty as soon as the term has been added - so a field with
             * several terms ticked is reported as empty and the form cannot be
             * submitted. What matters is what is selected. See #8131.
             *
             * Registered for terms only: a plain checkbox list has no element that
             * is part of the field but not one of its options, so changing its
             * behaviour here is not needed to fix this and is left to Engineering.
             */
            nfRadio.channel( 'terms' ).reply( 'validate:required', this.validateRequired, this );
        },

        /**
         * Whether anything is selected in this field.
         *
         * @param {Object} el    The element that changed; not used.
         * @param {Object} model The field model.
         * @return {boolean} True when at least one term is selected.
         */
        validateRequired: function( el, model ) {
            var selected = model.get( 'value' ) || [];
            if ( 'string' == typeof selected ) selected = selected ? [ selected ] : [];

            return 0 < _.filter( selected, function( value ) {
                return '' !== String( value ).trim();
            } ).length;
        },

        register: function( model ) {
            model.set( 'renderOptions', this.renderOptions );
            model.set( 'renderOtherText', this.renderOtherText );
            model.set( 'selected', [] );

            /*
             * When we init a model, we need to set our 'value' to the selected option's value.
             * This is the list equivalent of a 'default value'.
             */ 
            if ( 0 != model.get( 'options' ).length ) {
                var selected = _.filter( model.get( 'options' ), function( opt ) { return 1 == opt.selected } );
                selected = _.map( selected, function( opt ) { return opt.value } );
            }

            /*
            * This part is re-worked to take into account custom user-meta
            * values for fields.
             */
	        var savedVal = model.get( 'value' );
	        if( 'undefined' !== typeof savedVal && Array.isArray( savedVal ) ) {
		        model.set( 'value', savedVal );
	        } else if ( 'undefined' != typeof selected ) {
		        model.set( 'value', selected );
	        }
        },

        renderOptions: function() {
            var html = '';

            if ( '' == this.value || ( Array.isArray( this.value ) && 0 < this.value.length )
                || 0 < this.value.length ) {
                var valueFound = true;
            } else {
                var valueFound = false;
            }

            _.each( this.options, function( option, index ) {
                if( Array.isArray( this.value ) ) {
                	if( Array.isArray( this.value[ 0 ] ) && -1 !== _.indexOf( this.value[ 0 ], option.value ) ) {
                		valueFound = true;
	                }
                    else if( _.indexOf( this.value, option.value ) ) {
                        valueFound = true;
	                }
                }

                if ( option.value == this.value ) {
                    valueFound = true;
                }

                /*
                 * TODO: This is a bandaid fix for making sure that each option has a "visible" property.
                 * This should be moved to creation so that when an option is added, it has a visible property by default.
                 */
                if ( 'undefined' == typeof option.visible ) {
                    option.visible = true;
                }

                option.fieldID = this.id;
                option.classes = this.classes;
                option.index = index;
                option.label = (typeof nfFrontEnd.filter_esc_status !== "undefined" && nfFrontEnd.filter_esc_status === "true") ? _.escape(option.label) : option.label;
                
                var selected = false;
				/*
				* This part has been re-worked to account for values passed in
				* via custom user-meta ( a la User Mgmt add-on)
				 */
	            if( Array.isArray( this.value ) && 0 < this.value.length ) {
	            	/*
	            	 * Compare as text. A value that came from ticking a checkbox is a
	            	 * string read from the DOM, while an option value supplied by PHP -
	            	 * a Terms List term id - is a number. Comparing them strictly unticks
	            	 * the visitor's earlier choices whenever the field re-renders, which
	            	 * is exactly what adding a term does. See #8131.
	            	 */
	            	var optionValue = String( option.value );
	            	var chosenValues = _.map( this.value, function( chosen ) { return String( chosen ); } );
	            	var firstEntry = String( this.value[ 0 ] ).split( ',' );

	            	if ( -1 !== _.indexOf( firstEntry, optionValue )
		                || -1 !== _.indexOf( chosenValues, optionValue ) ) {
			            selected = true;
	            	}
	            } else if ( ! _.isArray( this.value ) && option.value == this.value ) {
		            selected = true;
	            } else if ( ( 1 == option.selected && this.clean ) && 'undefined' === typeof this.value ) {
		            selected = true;
	            }


                // else if( ( option.selected && "0" != option.selected ) && this.clean ){
	            //     isSelected = true;
	            // } else {
	            //     var testValues = _.map( this.value, function( value ) {
	            //         return value.toString();
	            //     } );
	            //
	            //     option.isSelected = ( -1 != testValues.indexOf( option.value.toString() ) );
	            // }
	            option.selected = selected;
	            option.isSelected = selected;
	            option.required = this.required;
                option.maybeFilterHTML = this.maybeFilterHTML;
                var template = nfRadio.channel( 'app' ).request( 'get:template',  '#tmpl-nf-field-listcheckbox-option' );
                html += template( option );
            }, this );

            if ( 1 == this.show_other ) {
                if ( 'nf-other' == this.value ) {
                    valueFound = false;
                }
                var data = {
                    fieldID: this.id,
                    classes: this.classes,
                    currentValue: this.value,
                    renderOtherText: this.renderOtherText,
                    valueFound: valueFound
                };

                var template = nfRadio.channel( 'app' ).request( 'get:template',  '#tmpl-nf-field-listcheckbox-other' );
                html += template( data );

            }

            return html;
        },

        renderOtherText: function() {
            if ( 'nf-other' == this.currentValue || ! this.valueFound ) {
                if ( 'nf-other' == this.currentValue ) {
                    this.currentValue = '';
                }
                var data = {
                    fieldID: this.fieldID,
                    classes: this.classes,
                    currentValue: this.currentValue
                };
                var template = nfRadio.channel( 'app' ).request( 'get:template',  '#tmpl-nf-field-listcheckbox-other-text' );
                return template( data );
            }
        },

        getCalcValue: function( fieldModel ) {
            var calc_value = 0;
            var options = fieldModel.get( 'options' );
            if ( 0 != options.length ) {
                _.each( fieldModel.get( 'value' ), function( val ) {
                    var tmp_opt = _.find( options, function( opt ) { return opt.value == val } );
                    if ( ! tmp_opt ) {
                        return;
                    }
                    /*
                     * An option with no usable calc value contributes nothing,
                     * which is what NF_Fields_ListCheckbox::get_calc_value()
                     * already does on the server. Adding a missing or
                     * non-numeric calc value here produced NaN (a blank one
                     * adds 0, since Number('') is 0), and that discarded the
                     * calc values of every other ticked option, so the whole
                     * calculation read as zero. See #1501.
                     */
                    var option_calc = tmp_opt.calc;
                    if ( '' === String( option_calc ).trim() || ! isFinite( Number( option_calc ) ) ) {
                        return;
                    }
                    calc_value = Number( calc_value ) + Number( option_calc );
                } );
            }
            return calc_value;
        },

        beforeUpdateField: function( el, model ) {
            var selected = model.get( 'value' ) || [];
            if ( typeof selected == 'string' ) selected = [ selected ];

            /*
             * The Terms List add-new-term box shares the 'nf-element' class so it
             * picks up field styling and the Enter key handling, but it is not one
             * of the field's options. Changing it must leave the selection alone -
             * reading it as an unticked checkbox rebuilds the selection from its
             * first entry and silently drops everything the visitor chose. See #8131.
             */
            if ( jQuery( el ).hasClass( 'extra-value' ) ) {
                return _.clone( selected );
            }

            var value = jQuery( el ).val();
            var checked = jQuery( el ).prop( 'checked' );
            if ( checked ) {
                selected.push( value );
                jQuery( el ).addClass( 'nf-checked' );
                jQuery( el ).parent().find( 'label[for="' + jQuery( el ).prop( 'id' ) + '"]' ).addClass( 'nf-checked-label' );
            } else {
                jQuery( el ).removeClass( 'nf-checked' );
                jQuery( el ).parent().find( 'label[for="' + jQuery( el ).prop( 'id' ) + '"]' ).removeClass( 'nf-checked-label' );
                var i = selected.indexOf( value );
                if( -1 != i ){
                    selected.splice( i, 1 );
                } else if ( Array.isArray( selected ) ) {
                	var optionArray = typeof selected[0] !== "undefined" ? selected[0].split( ',' ) : [];
                	var valueIndex = optionArray.indexOf( value );
                	if( -1 !== valueIndex) {
                		optionArray.splice( valueIndex, 1 );
	                }
                	selected = optionArray.join( ',' );
                }
            }

            // if ( 1 == model.get( 'show_other' ) ) {
            //     model.set( 'reRender', true );
            // }

            return _.clone( selected );
        }
    });

    return controller;
} );
